// Copyright (c) 2016 Deere & Company

import DateRange, {getDefaultState as getDateRangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/date-range';
import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import t from 'tcomb';

const Facets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    requestedDateRange: t.struct({
        dateRange: DateRange,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    })
}, 'Facets');

export const getDefaultState = () =>
    new Facets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        requestedDateRange: {
            dateRange: getDateRangeDefaultState(),
            maxDate: null,
            minDate: null
        }
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/state/facets.js